/**
 * Builds API filter criteria from form data based on page context.
 * @param {Object} filterForm - Form data with filter values
 * @param {Object} data - Additional data (currently unused)
 * @param {string} page - Page identifier determining filter structure
 * @returns {Object} Filter criteria with empty values removed
 */
export const filterCriteria = (filterForm, data, page) => {
  const filterCriteria = {};

  if (page === "updateEngine") {
    filterCriteria.spaJobType = filterForm.jobType;
    filterCriteria.jobIds = filterForm?.jobId ?? "";
    filterCriteria.spaJobStatuses = Array.isArray(filterForm?.jobStatus)
      ? filterForm.jobStatus.length > 0
        ? filterForm.jobStatus.map((item) => item?.value ?? item)
        : ""
      : "";
  }

  if (page === "tapJobs") {
    filterCriteria.jobIds = filterForm?.jobId ?? "";
    filterCriteria.spaJobType = filterForm?.jobType?.value ?? "";
    filterCriteria.spaJobStatuses = Array.isArray(filterForm?.jobStatus)
      ? filterForm.jobStatus.length > 0
        ? filterForm.jobStatus.map((item) => item?.value ?? item)
        : ""
      : "";
  }
  if (page === "jobTasks") {
    filterCriteria.jobId = filterForm?.jobId ?? "";
    filterCriteria.spaJobStatus = filterForm?.taskStatus?.value ?? "";
  }

  if (page === "pmxPricesAndDates") {
    filterCriteria.isHistorical = filterForm?.isHistoricalRecord?.value ?? "";
    filterCriteria.catalogId = filterForm?.catalogId ?? "";
    filterCriteria.catalogName = filterForm?.catalogName ?? "";
    filterCriteria.pmxReleaseId = (filterForm?.pmxReleaseId ?? "").trim();
    filterCriteria.productType = filterForm?.productType?.value ?? "";
    filterCriteria.territories = Array.isArray(filterForm?.territory)
      ? filterForm.territory.length > 0
        ? filterForm.territory.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.productPlatforms = Array.isArray(filterForm?.productPlatform)
      ? filterForm.productPlatform.length > 0
        ? filterForm.productPlatform.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.productConfigs = Array.isArray(filterForm?.productConfig)
      ? filterForm.productConfig.length > 0
        ? filterForm.productConfig.map((item) => item?.value ?? item)
        : ""
      : "";
  }

  if (page === "pmxDeliveries") {
    filterCriteria.skuId = filterForm?.skuId ?? "";
    filterCriteria.action = filterForm?.action?.value ?? "";
    filterCriteria.status = filterForm?.status?.value ?? "";
  }

  if (page === "users") {
    filterCriteria.fullName = filterForm?.name ?? "";
    filterCriteria.emailAddress = filterForm?.email ?? "";
    filterCriteria.roleIds = Array.isArray(filterForm?.role)
      ? filterForm.role.length > 0
        ? filterForm.role.map((item) => item?.value ?? item)
        : ""
      : "";
  }

  if (page === "tprExceptions") {
    filterCriteria.releaseId = filterForm?.releaseId ?? "";
    filterCriteria.releaseTitle = filterForm?.releaseTitle ?? "";
    filterCriteria.dealId = filterForm?.dealId ?? "";
    filterCriteria.catalogId = filterForm?.catalogId ?? "";
    filterCriteria.catalogName = filterForm?.catalogName ?? "";
    filterCriteria.licensee = filterForm?.licensee ?? "";

    if (filterForm?.mineOnly === true) {
      filterCriteria.mineOnly = true;
    }

    filterCriteria.users = Array.isArray(filterForm?.users)
      ? filterForm.users.length > 0
        ? filterForm.users.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.statuses = Array.isArray(filterForm?.exceptionStatus)
      ? filterForm.exceptionStatus.length > 0
        ? filterForm.exceptionStatus.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.types = Array.isArray(filterForm?.exceptionType)
      ? filterForm.exceptionType.length > 0
        ? filterForm.exceptionType.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.territories = Array.isArray(filterForm?.territories)
      ? filterForm.territories.length > 0
        ? filterForm.territories.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.medias = Array.isArray(filterForm?.medias)
      ? filterForm.medias.length > 0
        ? filterForm.medias.map((item) => item?.value ?? item)
        : ""
      : "";
  }

  if (page === "rateCards") {
    filterCriteria.jId = filterForm?.rateCardId ?? "";
    filterCriteria.rateCardName = filterForm?.rateCardNameKeywords ?? "";
    filterCriteria.includeAllOrAny = filterForm?.keywordMatchType ?? "all";
    filterCriteria.isTpr = filterForm?.tprDisplay ?? "hide";
    filterCriteria.users = Array.isArray(filterForm?.users)
      ? filterForm.users.length > 0
        ? filterForm.users.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.statuses = Array.isArray(filterForm?.status)
      ? filterForm.status.length > 0
        ? filterForm.status.map((item) => item?.value ?? item)
        : ""
      : "";
  }

  if (page === "licensingJobs") {
    const jobIdParts = String(filterForm.jobId ?? "")
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);
    if (jobIdParts.length > 0) {
      filterCriteria.jId = jobIdParts.join(",");
    }
    filterCriteria.catalogId = filterForm.catalogId;
    filterCriteria.catalogName = filterForm.catalogName;
    filterCriteria.users = Array.isArray(filterForm?.users)
      ? filterForm.users.length > 0
        ? filterForm.users.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.statuses = Array.isArray(filterForm?.status)
      ? filterForm.status.length > 0
        ? filterForm.status.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.mediaIds = Array.isArray(filterForm?.media)
      ? filterForm.media.length > 0
        ? filterForm.media.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.territoryIds = Array.isArray(filterForm?.territory)
      ? filterForm.territory.length > 0
        ? filterForm.territory.map((item) => item?.value ?? item)
        : ""
      : "";
    if (
      Array.isArray(filterForm.licenseeType) &&
      filterForm.licenseeType.length > 0
    ) {
      filterCriteria.licenseeTypeList = filterForm.licenseeType;
    }
    filterCriteria.isTpr = filterForm.tprDisplay ?? "hide";
  }

  if (page === "windowSequences") {
    filterCriteria.jId = filterForm?.windowId ?? "";
    filterCriteria.windowSequenceName = filterForm?.windowSequenceName ?? "";
    filterCriteria.users = Array.isArray(filterForm?.users)
      ? filterForm.users.length > 0
        ? filterForm.users.map((item) => item?.value ?? item)
        : ""
      : "";
    filterCriteria.statuses = Array.isArray(filterForm?.status)
      ? filterForm.status.length > 0
        ? filterForm.status.map((item) => item?.value ?? item)
        : ""
      : "";
  }

  return Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );
};
